<template>
  <div class="main_con">
    <div class="nkt_main" v-if="nktList.length">
      <div class="nkt_con">
        <div id="box" ref="box">
          <img :src="imgPath + 'sImgMax/' + nktList[current].imgid + '.jpg'" alt="">
          <div class="icon_con">
            <div v-for="(item, index) in nktList[current].zb" :key="index" :style="pxToRem(item)" @click="getDetail(item.buildingId)">
              <span class="blue" :class="buildingId === item.buildingId ? 'red' : ''" v-show="radio == 1 && item.build.ksts != 0">#{{item.build.buildName}}</span>
              <span class="origin" :class="buildingId === item.buildingId ? 'red' : ''" v-show="radio == 2 && item.build.ksts == 0">#{{item.build.buildName}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select_con">
        <van-field
          readonly
          clickable
          name="picker"
          :value="value"
          placeholder="点击选择鸟瞰图"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="nktList"
            value-key="ms"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>
      <div class="bottom_con m_flex_box">
        <transition name="slide-fade">
          <div class="inner_con" v-show="isToggle">
            <van-radio-group v-model="radio" class="m_flex_box flex_vc">
              <div class="inner col_blue">
                <van-radio icon-size="0.3rem" name="1">在售</van-radio>
              </div>
              <div class="inner col_ori">
                <van-radio checked-color="#FF5129" icon-size="0.3rem" name="2">售罄</van-radio>
              </div>
            </van-radio-group>
          </div>
        </transition>
        <div class="toggle" @click="isToggle = !isToggle">{{isToggle ? '收起' : '展开'}}</div>
      </div>
    </div>
    <div class="b_con" v-show="obj.buildName">
      <div class="top m_flex_box flex_vc flex_jz">
        <h4 class="m_flex_box flex_vc">
          <span>{{obj.buildName}}#</span>
          <i>{{obj.ksts !== 0 ? '在售' : '售罄'}}</i>
        </h4>
        <router-link :to="'/saleInfo?itemId=' + itemId" class="m_flex_box flex_vc">
          <span>销售信息</span>
          <van-icon name="arrow" />
        </router-link>
      </div>
      <p class="col_gray">（图片标记为已取得预售楼盘,未取得预售楼盘暂不显示）</p>
      <div class="b_inner">
        <div class="row m_flex_box">
          <p class='flex-1'>入网总套数：<span>{{obj.rwts}}套</span></p>
          <p class='flex-1'>未销售套数：<span>{{obj.ksts}}套</span></p>
        </div>
        <div class="row m_flex_box">
          <p class='flex-1'>已备案套数：<span>{{obj.cjts}}套</span></p>
          <p class='flex-1'>入网总面积：<span>{{obj.totalArea}}m²</span></p>
        </div>
        <div class="row m_flex_box">
          <p class='flex-1'>未销售面积：<span>{{(obj.totalArea * 1 - obj.cjmj * 1).toFixed(2)}}m²</span></p>
          <p class='flex-1'>已备案面积：<span>{{obj.cjmj}}m²</span></p>
        </div>
        <div class="row m_flex_box">
          <p class='flex-1'>规划用途：<span>{{obj.planUse}}套</span></p>
          <p class='flex-1'>建筑结构：<span>{{obj.struct}}套</span></p>
        </div>
        <div class="row m_flex_box">
          <p class='flex-1'>总层数：<span>{{obj.layerNum}}层</span></p>
          <p class='flex-1'>地上层数：<span>{{obj.upLayerNum}}层</span></p>
        </div>
        <div class="row m_flex_box">
          <p class='flex-1'>地下层数：<span>{{obj.underLayerNum}}层</span></p>
          <p class='flex-1'>是否有电梯：<span>{{obj.liftMark ? '有' : '无'}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
export default {
  data() {
    return {
      iconArr: [{
        top: 94,
        left: 196
      },{
        top: 171,
        left: 280
      }],
      columns: [],
      value: '',
      showPicker: false,
      radio: '1',
      isToggle: true,
      current: 0,
      nktList: [],
      obj: {},
      buildingId: '',
      itemId: ''
    };
  },
  mounted() {
    this.current = this.$route.query.type
    this.itemId = this.$route.query.itemId
    this.getNkt();
  },
  methods: {
    pxToRem(v) {
      return 'top:' + (v.offsetY - 18) + 'px;' + 'left:' + (v.offsetX - 12) + 'px';
    },
    onConfirm(v) {
      this.value = v.ms;
      this.nktList.forEach((item, index) => {
        if(item.ms === v.ms) {
          this.current = index
        }
      });
      this.showPicker = false
    },
    getNkt() {
      this.$new.post('itemInfo/getAerialViewByItem.do', qs.stringify({
        itemId: this.itemId
      })).then(res => {
        this.nktList = res.obj || [];
        this.value = res.obj[this.current].ms
      })
    },
    getDetail(id) {
      this.buildingId = id
      this.nktList[this.current].zb.forEach((item, index) => {
        if(item.buildingId === id) {
          this.obj = this.nktList[this.current].zb[index].build
        }
      });
    }
  },
};
</script>
<style lang="less" scoped>
.nkt_main{
  position: relative;
}
.select_con{
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  z-index: 10;
  /deep/
  .van-cell{
    height: 0.6rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    width: 2.4rem;
    padding: 0;
    background-color: rgba(0,0,0,0.6);
    border-radius: 0.3rem;
    &:after{
      display: none!important;
    }
    /deep/
    .van-field__control{
      height: 0.6rem;
      text-align: center;
      font-size: 0.26rem;
      color: #fff;
      &::-webkit-input-placeholder {
        color: #fff;
      }
      &:-moz-placeholder {
        color: #fff;
      }
      &::-moz-placeholder {
        color: #fff;
      }
      &:-ms-input-placeholder {
        color: #fff;
      }
    }
  }
}
.nkt_con{
  width: 100%;
  height: 5.26rem;
  overflow: auto;
  #box{
    width: 800px;
    height: 600px;
    position: relative;
    transform-origin: 0 0;
    img{
      width: 800px;
      height: 600px;
      display: block;
      margin: auto;
    }
    .icon_con{
      background-color: rgba(255,255,2, 0.5);
      div{
        position: absolute;
      }
      span{
        color: #fff;
        display: block;
        padding: 0.06rem 0.1rem;
        font-size: 0.22rem;
        border-radius: 0.04rem;
        top: 0.28rem;
        z-index: 2;
        &.blue{
          background-color: #3072f5d3;
          &:after{
            border-color: #3072f5d3 transparent transparent transparent;
          }
        }
        &.origin{
          background-color: #fa7659;
          &:after{
            border-color: #fa7659 transparent transparent transparent;
          }
        }
        &.red{
          background-color: #f13535!important;
          &:after{
            border-color: #f13535 transparent transparent transparent!important;
          }
        }
        &:after{
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0.1rem;
          position: absolute;
          left: 50%;
          margin-left: -0.1rem;
        }
      }
    }
  }
}
.bottom_con{
  position: absolute;
  bottom: 0.2rem;
  right: 0.2rem;
  z-index: 9;
  .inner_con{
    .inner{
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 0.08rem;
      padding: 0.1rem 0.2rem;
      margin-left: 0.2rem;
    }
    .col_blue{
      /deep/
      .van-radio__label{
        color: #1989fa;
      }
    }
    .col_ori{
      /deep/
      .van-radio__label{
        color: #FF5129;
      }
    }
  }
  .toggle{
    background-color: rgba(0,0,0,0.8);
    border-radius: 0.08rem;
    height: 0.6rem;
    width: 1.34rem;
    color: #fff;
    font-size: 0.24rem;
    line-height: 0.6rem;
    text-align: center;
    margin-left: 0.2rem;
  }
}
.b_con{
  width: 7.04rem;
  padding: 0.3rem 0;
  margin: 0 auto;
  .top{
    padding-bottom: 0.3rem;
    h4{
      span{
        font-size: 0.42rem;
        color: #202020;
        font-weight: 800;
        margin-right: 0.2rem;
      }
      i{
        color: #2F72F5;
        font-size: 0.22rem;
        border: 1px solid currentColor;
        padding: 0.02rem 0.04rem;
      }
    }
    p{
      font-size: 0.24rem;
      color: #A0A0A0;
      span{
        margin-right: 0.08rem;
      }
    }
  }
  .col_gray{
    font-size: 0.22rem;
    color: #8E91A0;
    margin-bottom: 0.2rem;
  }
  .b_inner{
    .row{
      padding: 0.3rem 0;
      border-bottom: 1px solid #f4f4f4;
      p{
        font-size: 0.26rem;
        color: #909090;
        span{
          color: #303030;
        }
      }
    }
  }
}
</style>